import App from "../App";
import SsoRegister from '../views/SsoRegistration/SsoRegister.js';


var indexRoutes = [{ path: "/", name: "Home", component: App }];

export default indexRoutes;
